/**
 * Отметки «не совсем понятно» на шагах разбора задачи и на разделах разбора
 * темы. Общее для схемы, функций (convex/unclear.ts) и экранов.
 *
 * Ученик называет только место — номера шагов или разделы — и, если хочет,
 * пишет комментарий. Причин на выбор нет (убраны 29 сентября 2026): четыре
 * кнопки «что именно» просили классифицировать непонимание того, кто как раз
 * не понял, а комментарий словами говорит больше любой из них.
 */
import { v } from "convex/values";

/** Раздел страницы темы — те же четыре поля, что у таблицы `theory`. */
export const theorySection = v.union(
  v.literal("why"),
  v.literal("rule"),
  v.literal("example"),
  v.literal("mistake"),
);
export type TheorySection = "why" | "rule" | "example" | "mistake";
export const THEORY_SECTIONS: TheorySection[] = ["why", "rule", "example", "mistake"];

/** Шаг разбора, запомненный при отметке, — не длиннее этого. */
export const STEP_TEXT_MAX = 600;
/** Комментарий ученика к отметке. */
export const COMMENT_MAX = 1000;
/** Больше шагов в разборе не бывает; защита от мусорного массива. */
export const STEPS_MAX = 40;

/**
 * Версия раздела темы — короткий хэш его текста (FNV-1a, 32 бита).
 *
 * Не криптография: нужно только заметить, что текст сменился, и отличить
 * одну версию от другой в сводке автора. Хранить сам текст в каждой отметке
 * незачем — раздел бывает в килобайт, а отметок на нём десятки.
 */
export function sectionRev(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, "0");
}
